var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"2em"}},_vm._l((_vm.widgets),function(widget){return _c('div',{key:widget.id},[_c('div',{staticStyle:{"margin-top":"1em"}},[_c(widget.type,{tag:"component",attrs:{"widget":widget}})],1)])}))}
var staticRenderFns = []

export { render, staticRenderFns }